module.exports = __webpack_public_path__ + "img/arr1.d516a7ea.svg";